import { Injectable, inject } from '@angular/core';
import {tap} from 'rxjs/operators';
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class GoogleAuthService {
  private http = inject(HttpClient);


  public url: string;

  getGoogleUrl() {
    return this.http.get<string>('/api/auth/google-url')
      .pipe(
        tap(
          (url: string) => this.url = url
        )
      );
  }

  /**
   * To be called after the user returns from google's oauth page.  Google will
   * pass us a code, that we must validate server side.
   */
  authenticateGoogleCode(code: string) {
    const postData = {code: code};

    return this.http.post<{ token: string }>('/api/auth/google', postData);
  }
}
